import { createReducer, on } from '@ngrx/store';
import * as PdfDownloadActions from '../actions/pdf-download.actions';

export interface PdfDownloadState {
  hasError: boolean;
  isFetching: boolean;
  pdfResponse: ArrayBuffer | null;
  entityUrl?: string;
  version?: string;
}

export const initialState: PdfDownloadState = {
  hasError: false,
  isFetching: false,
  pdfResponse: null,
  entityUrl: undefined,
  version: undefined,
};

export const pdfDownloadReducer = createReducer(
  initialState,
  on(PdfDownloadActions.getPdfDownloadRequest, (state) => ({
    ...state,
    ...initialState,
    isFetching: true,
  })),
  on(PdfDownloadActions.getNewPdfDownloadRequest, (state) => ({
    ...state,
    ...initialState,
    isFetching: true,
  })),
  on(
    PdfDownloadActions.getPdfDownloadSuccess,
    (state, { pdfResponse, entityUrl, version }) => ({
      ...state,
      isFetching: false,
      hasError: false,
      pdfResponse,
      entityUrl,
      version,
    })
  ),
  on(PdfDownloadActions.getPdfDownloadFailure, (state) => ({
    ...state,
    isFetching: false,
    hasError: true,
    pdfResponse: null,
    entityUrl: undefined,
  })),
  on(PdfDownloadActions.resetPdfDownload, (state) => ({
    ...state,
    ...initialState,
  }))
);
